import { QuizMachineContext } from '../../context'

export const useSubcatInterestsEventData = (subcatIds: number[]) =>
  QuizMachineContext.useSelector(({ context }) => {
    const selCats = context.allCategories.filter((c) =>
      (context.categoryInterestsCSV || '').split(',').includes(c.id.toString()),
    )

    const selSubcats = context.allSubcategories.filter((sc) =>
      subcatIds.includes(sc.id),
    )

    // sub-step number is the index of the current subcat selection step
    // e.g. first subcat interest screen = substep 1
    //     second subcat interest screen = substep 2, etc
    // this step number can be derived from context:
    //  - catsToRefineSubcats is the list of category ids that need subcat refinement
    //  - selCats is the list of categories that the user has selected
    const subStepNumber =
      selCats.length - (context.catsToRefineSubcats || []).length + 1

    return {
      subStepNumber,
      selectedCategories: selCats.map((c) => c.name),
      selectedCategoryIds: selCats.map((c) => c.id),
      selectedSubcategoryIds: subcatIds,
      selectedSubcategories: selSubcats.map((sc) => sc.name),
    }
  })
